import { render, staticRenderFns } from "./title.vue?vue&type=template&id=b377ec8e&scoped=true&"
import script from "./title.vue?vue&type=script&lang=js&"
export * from "./title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b377ec8e",
  null
  
)

export default component.exports